import script from "./UserNote.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNote.vue?vue&type=script&setup=true&lang=js"

import "./UserNote.vue?vue&type=style&index=0&id=6f7de889&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7de889"]])

export default __exports__